export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';
export const ENV = process.env.REACT_APP_ENV || 'development';
export const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_BASE_URL || 'http://localhost:8000';